"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const AutocompleteContext_1 = require("./AutocompleteContext");
const ARROW_DOWN_KEY = 40;
const ARROW_UP_KEY = 38;
const ENTER_KEY = 13;
const ESCAPE_KEY = 27;
const BACKSPACE_KEY = 8;
function useAutocompleteKeyboardControl(noTags) {
    const { desktop } = (0, libs_context_device_type_1.useDeviceType)();
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    const { focused } = (0, libs_hooks_dom_1.useWatchingFocus)(ctx.inputRef);
    (0, react_1.useEffect)(() => {
        if (!focused || (!desktop && !noTags))
            return;
        function onKeyDown(event) {
            const { keyCode } = event;
            switch (keyCode) {
                case ARROW_DOWN_KEY:
                    ctx.focusNext();
                    event.preventDefault(); // Prevents the cursor from moving
                    break;
                case ARROW_UP_KEY:
                    ctx.focusPrev();
                    event.preventDefault(); // Prevents the cursor from moving
                    break;
                case ENTER_KEY:
                    ctx.pickFocused(noTags);
                    event.preventDefault();
                    break;
                case ESCAPE_KEY:
                    ctx.closeSuggestions();
                    break;
                case BACKSPACE_KEY:
                    ctx.backspace(noTags);
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return function cleanListenersUp() {
            document.removeEventListener('keydown', onKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [desktop, focused]);
}
exports.default = useAutocompleteKeyboardControl;
//# sourceMappingURL=useAutocompleteKeyboardControl.js.map